export const TRIP_START = "2026-10-20";
export const TRIP_END = "2026-10-29";

export const TRIP_DATES = Array.from({ length: 10 }, (_, i) => {
  const d = new Date(Date.UTC(2026, 9, 20 + i));
  return d.toISOString().slice(0, 10);
});

export const WEEKDAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const toDate = (iso) => new Date(`${iso}T00:00:00`);
export const isoOf = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const addDays = (iso, n) => { const d = toDate(iso); d.setDate(d.getDate() + n); return isoOf(d); };

export const weekdayShort = (iso) => WEEKDAYS[toDate(iso).getDay()].slice(0, 3);
export const weekdayLong = (iso) => WEEKDAYS[toDate(iso).getDay()];
export const dayNum = (iso) => toDate(iso).getDate();
export const fmtLong = (iso) => `${weekdayLong(iso)} ${dayNum(iso)} ${MONTHS[toDate(iso).getMonth()]}`;
export const fmtShort = (iso) => `${weekdayShort(iso)} ${dayNum(iso)} ${MONTHS[toDate(iso).getMonth()].slice(0, 3)}`;
export const fmtDayMonth = (iso) => `${dayNum(iso)} ${MONTHS[toDate(iso).getMonth()].slice(0, 3)}`;

export const fmtTime = (hhmm) => {
  if (!hhmm) return null;
  const [h, m] = hhmm.split(":").map(Number);
  const suffix = h >= 12 ? "PM" : "AM";
  const hr = h % 12 === 0 ? 12 : h % 12;
  return `${hr}:${String(m).padStart(2, "0")} ${suffix}`;
};

export const parseTimeInput = (raw) => {
  if (!raw) return null;
  const m = String(raw).trim().toLowerCase().match(/^(\d{1,2})(?::(\d{2}))?\s*(am|pm|a\.m\.|p\.m\.)?$/);
  if (!m) return null;
  let h = Number(m[1]);
  const min = Number(m[2] || 0);
  const ap = m[3];
  if (ap?.startsWith("p") && h < 12) h += 12;
  if (ap?.startsWith("a") && h === 12) h = 0;
  if (h > 23 || min > 59) return null;
  return `${String(h).padStart(2, "0")}:${String(min).padStart(2, "0")}`;
};

export const daysBetween = (a, b) => Math.round((toDate(b) - toDate(a)) / 86400000);

export const tripPhase = (todayIso) => {
  if (todayIso < TRIP_START) return { phase: "before", daysUntil: daysBetween(todayIso, TRIP_START) };
  if (todayIso > TRIP_END) return { phase: "after", daysSince: daysBetween(TRIP_END, todayIso) };
  return { phase: "during", dayNumber: daysBetween(TRIP_START, todayIso) + 1, nightsLeft: daysBetween(todayIso, TRIP_END) };
};

export const hotelForNight = (hotels, iso) => hotels.find((h) => h.checkIn <= iso && iso < h.checkOut) || null;
export const clampToTrip = (iso) => (iso < TRIP_START ? TRIP_START : iso > TRIP_END ? TRIP_END : iso);
